'use client';

import { Box } from '@osmosis/tailwind-ui/components/Box';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import React from 'react';
import { useAIPanelHeightSync } from '../../../context/AIPanelHeightSyncContext';

type Props = {
  children: React.ReactNode;
  /**
   * When true (default) the group's combined height is registered with the AI-panel height sync. Pass false when
   * there is no video, so the AI panel falls back to its default height.
   */
  syncHeight?: boolean;
  className?: string;
};

/**
 * The expanded AI panel's top aligns with this group's top, so registering the whole group — rather
 * than just the feature box — makes the panel's bottom line up with the video
 * player's bottom even when the admin toolbar is present above the video.
 */
const LearnFeatureGroup = ({
  children,
  syncHeight = true,
  className,
}: Props) => {
  const { registerMatchTarget } = useAIPanelHeightSync();

  return (
    <Box
      ref={syncHeight ? registerMatchTarget : null}
      data-testid="learn-feature-group"
      className={cn('flex flex-col gap-2', className)}
    >
      {children}
    </Box>
  );
};

export default LearnFeatureGroup;
